import Vue from 'vue'
import ToastComponent from './main.vue'
import { duration } from './constant.js'

const ToastConstructor = Vue.extend(ToastComponent)
let instance

ToastConstructor.prototype.close = _ => {
  this.visible = false
}

const initInstance = _ => {
  instance = new ToastConstructor().$mount(document.createElement('div'))
}

const Toast = options => {
  // 共用一个实例
  if (!instance) {
    initInstance()
  }
  instance.duration = options.duration ? options.duration : duration
  instance.clearTimer()
  instance.createTimer()
  instance.message = (typeof options === 'string' || typeof options === 'number') ? options : options.message
  document.body.appendChild(instance.$el)
  instance.visible = true

  return instance
}
export default Toast
